import { BasketFillIcon } from './BasketFillIcon';

/**
 * author: Austin Andrews
 * id 9B7DC550-62F9-4FB0-9B21-0379AA925A19
 * name basket-fill
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-fill.svg
 * tags
 * - Shopping 
 */
export const SkipFillIcon = BasketFillIcon;
export default SkipFillIcon